import { createApi, fetchData, formatParams, getApi, updateApi } from '@/lib/api.service.js'

const currentUrl = `${import.meta.env.VITE_BACKEND_URL}/api/v2/servicechek/car`;

export async function indexCars(params = null) {
  try {
    let url = `${currentUrl}s`;
    return await fetchData(url, params);
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function getCar(id){
  try {
    let url = `${currentUrl}s/${id}`;
    const response = await getApi(url);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function createCar(data) {
  data = formatParams(data);

  try {
    const response = await createApi(currentUrl, data);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function updateCar(id, data) {
  data = formatParams(data);

  try {
    let url = `${currentUrl}/${id}`;
    const response = await updateApi(url, data);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}